// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateCreateOtherSubjectBindingAdmin, ValidateCreateOtherSubjectBindingAdminSchema } from 'api/gen/ValidateCreateOtherSubjectBindingAdmin';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateUpdateOtherSubjectBindingAdmin, ValidateUpdateOtherSubjectBindingAdminSchema } from 'api/gen/ValidateUpdateOtherSubjectBindingAdmin';

export const ValidateOtherSubjectBindingAdminSchema = t.union([ValidateCreateOtherSubjectBindingAdminSchema, ValidateUpdateOtherSubjectBindingAdminSchema]);

export type ValidateOtherSubjectBindingAdmin = t.TypeOf<typeof ValidateOtherSubjectBindingAdminSchema>;
